import Vue from 'vue'
import Router from 'vue-router'
import Support from '../pages/Support.vue'
import Layout from '../components/Layout'
import Multiplespace from '../pages/multiplespace/index.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: 'home',
          component: () => import('../pages/Home.vue'),
          name: 'home',
          meta: { title: '芃荟网络-首页' }
        },
        {
          path: 'reports',
          component: () => import('../pages/Reports.vue'),
          name: 'reports',
          meta: { title: '芃荟网络-关于我们' }
        },
        {
          path: 'vip',
          component: () => import('../pages/Vip.vue'),
          name: 'vip',
          meta: { title: '芃荟网络VIP中心' }
        },
        {
          path: 'login',
          component: () => import('../pages/Login.vue'),
          name: 'login',
          meta: { title: '芃荟网络-登录' }
        },
        {
          path: 'register',
          component: () => import('../pages/Register.vue'),
          name: 'register',
          meta: { title: '芃荟网络-注册' }
        }
      ]
    },
    {
      path: '/support',
      name: 'support',
      component: Support,
      meta: {
        title: 'Contact us'
      }
    },
    {
      path: '/multiplespace',
      component: Multiplespace,
      children: [
        {
          path: 'privacy',
          component: () => import('../pages/multiplespace/privacy.vue'),
          name: 'privacy',
          meta: { title: 'Multiple Space Privacy Policy' }
        },
        {
          path: 'agreement',
          component: () => import('../pages/multiplespace/agreement.vue'),
          name: 'agreement',
          meta: { title: 'Terms of Use' }
        },
        {
          path: 'member',
          component: () => import('../pages/multiplespace/member.vue'),
          name: 'member',
          meta: { title: 'Terms of Multiple Space Member' }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '芃荟网络'
  next()
})

export default router